
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import LoadingScreen from "./components/feature/LoadingScreen";
import { useState, Suspense, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && (
          <LoadingScreen onLoadingComplete={() => setIsLoading(false)} />
        )}
      </AnimatePresence>

      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <motion.div
          className="flex flex-col min-h-screen"
          initial={{ opacity: 0 }}
          animate={{ opacity: isLoading ? 0 : 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Navbar />
          <main className="flex-grow">
            <Suspense
              fallback={
                <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
                  <motion.div
                    className="w-8 h-8 rounded-full border-2 border-[#FF6B6B] border-t-transparent"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                  />
                </div>
              }
            >
              <AppRoutes />
            </Suspense>
          </main>
          <Footer />
        </motion.div>
      </BrowserRouter>
    </>
  );
}

export default App;
